import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import tinycolor from 'tinycolor2';
import Popover from '@material-ui/core/Popover';
import Button from '../Button';
import ColorPicker from '../ColorPicker';
import InputHelperText from '../InputHelperText';
import Row from '../../layout/Row';
import InputLabel from '../InputLabel';
import { makeStyles } from '../../styles';
import { buttonReset } from '../../mixins';
export const ColorField = ({ label, value = '', onChange = () => { }, onClose, disabled, defaultColor, helperText = '', error = false, }) => {
    const classes = useStyles();
    // State
    const [isColorSelectorOpen, setIsColorSelectorOpen] = React.useState(false);
    // Refs
    const colorSelectorRef = React.useRef(null);
    // Memoizers
    const styles = React.useMemo(() => {
        if (!value) {
            return {
                backgroundColor: 'inherit',
                color: 'inherit',
            };
        }
        const color = tinycolor(value);
        const isDark = color.isDark();
        return {
            backgroundColor: value,
            color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.9)',
        };
    }, [value]);
    // Callbacks
    const handleClose = React.useCallback(() => {
        setIsColorSelectorOpen(false);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    // Render
    return (_jsxs("div", Object.assign({ className: classes.root }, { children: [_jsx(InputLabel, { children: label }), _jsxs(Row, { children: [_jsx("button", Object.assign({ ref: colorSelectorRef, className: classes.button, style: styles, onClick: () => setIsColorSelectorOpen(true), disabled: disabled }, { children: value })), defaultColor && (_jsx(Button, Object.assign({ onClick: () => onChange(defaultColor) }, { children: "Reset" })))] }), _jsx(Popover, Object.assign({ anchorEl: colorSelectorRef.current, open: isColorSelectorOpen, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, { children: _jsx(ColorPicker, { value: value, onChange: onChange, onClose: handleClose }) })), helperText && (_jsx(InputHelperText, Object.assign({ indent: true, error: error, disabled: disabled }, { children: helperText })))] })));
};
const useStyles = makeStyles((theme) => ({
    root: {},
    button: Object.assign(Object.assign({}, buttonReset()), { cursor: 'pointer', width: '100%', height: 40, padding: theme.spacing(1, 2), fontSize: theme.fontSizes.md, borderRadius: theme.borderRadius.sm }),
}));
export default ColorField;
//# sourceMappingURL=ColorField.js.map